module.exports = "<div class=\"row\">\n  <div class=\"col-9\">\n    <p>{{ time }}</p>\n    <p>{{ timezone }}</p>\n  </div>\n\n  <div class=\"col-3\">\n    <button type=\"button\" class=\"btn-site\" (click)=\"setEditMode()\">Edit</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/clock/clock.component.html
// module id = ./src/app/dashboard/parks/park/clock/clock.component.html
// module chunks = main